import Link from "@/components/Link";
import Icon from "@ide/shared/components/Icon";

const UserProfileLink = ({ user }) => {
  return (
    <Link href={user ? "/account" : "/login"} className="h-full flex flex-col justify-center">
      <Icon icon="fa-user fa-regular" className="w-4 p-2" />
    </Link>
  );
};

export default UserProfileLink;
